import { useTranslation } from 'react-i18next';

import getFontFaceFontFamily from '@app/libs/fieldFontFamily';
import FontType from '@app/store/FontType';

import './TextFieldFontLoader.scss';

function TextFieldFontLoader() {
  const NotoSans = getFontFaceFontFamily(FontType.NOTO_SANS);
  const NotoSerif = getFontFaceFontFamily(FontType.NOTO_SERIF);
  const { t } = useTranslation();

  return (
    <div
      aria-hidden="true"
      className="TextFieldFontLoader"
      style={{ position: 'absolute', visibility: 'hidden' }}
    >
      <div style={{ fontFamily: NotoSans }}>{t('TextFieldFontLoader-text')}</div>
      <div style={{ fontFamily: NotoSerif }}>{t('TextFieldFontLoader-text')}</div>
    </div>
  );
}

export default TextFieldFontLoader;
